import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { MyContext } from "../../Context/MyContext";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonsGroup from "./ButtonsGroup";
import { RegisterFormContext } from "../../Context/RegisterFormContext";

export default function ScreenOne() {
  const { subjectsArray } = useContext(MyContext);
  const { formData, setFormData, one, three, setAvailableScreens } =
    useContext(RegisterFormContext);

  const [otherChecked, setOtherChecked] = useState(false);
  const [otherText, setOtherText] = useState("");

  const mypSubjectsOne = [
    "History",
    "Geography",
    "Economics",
    "Biology",
    "Chemistry",
    "Physics",
    "Integrated Science",
    "Mathematics",
    "Extended Mathematics",
    "Visual Arts",
    "Physical Education",
    "Health Education",
    "Product Design",
    "Digital Design",
    "Computer Science",
    "Integrated Humanities"
  ];

  // const mypSubjectsTwo = [
  //   "History",
  //   "Geography",
  //   "Economics",
  //   "Biology",
  //   "Chemistry",
  //   "Physics",
  //   "Integrated Science",
  //   "Mathematics",
  //   "Extended Mathematics",
  //   "Visual Arts",
  //   "Music",
  //   "Theater",
  //   "Dance",
  //   "Physical Education",
  //   "Health Education",
  //   "Product Design",
  //   "Digital Design",
  //   "Computer Science",
  // ];

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (!formData.selectedSubjects.includes(value)) {
      setFormData((prev) => ({
        ...prev,
        selectedSubjects: [...(prev.selectedSubjects || []), value],
      }));
    }
  };

  const handleDelete = (subjectToDelete) => {
    setFormData((prev) => ({
      ...prev,
      selectedSubjects: prev.selectedSubjects.filter(
        (subject) => subject !== subjectToDelete
      ),
    }));
  };

  const handleOptionChange = (event) => {
    const { checked } = event.target;
    setOtherChecked(checked);
    if (!checked) setOtherText("");
  };

  function handlePrev() {
    if (one.current) {
      one.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setTimeout(() => {
        setAvailableScreens((prev) => ({ ...prev, screen2: false }));
        setFormData((prev) => ({
          ...prev,
          selectedSubjects: [],
        }))
      }, 500);
    }
  }

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen3: true }));
    setTimeout(() => {
      if (three.current) {
        three.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  const [selectedSubjectsArray, setSelectedSubjectsArray] = useState([]);

  useEffect(() => {
    if (formData.program === "IB DP") {
      setSelectedSubjectsArray(subjectsArray);
    } else if (formData.program === "IB MYP") {
      // if (
      //   formData.class === "MYP - I (Year 1)" ||
      //   formData.class === "MYP - II (Year 2)"
      // ) {
      //   setSelectedSubjectsArray(mypSubjectsOne);
      // } else {
        setSelectedSubjectsArray(mypSubjectsOne);
      // }
    } else {
      setSelectedSubjectsArray([]);
    }
  }, [formData.program, formData.class]);

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <Typography variant="h6" style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}>
          Choose Subjects (Multiple Choice)
        </Typography>
        <div>
          <div style={{ width: "100%", maxWidth: "600px" }}>
            {otherChecked || selectedSubjectsArray?.length === 0 ? (
              <div
                style={{ display: "flex", alignItems: "baseline", gap: "10px" }}
              >
                <TextField
                  fullWidth
                  value={otherText}
                  onChange={(e) => setOtherText(e.target.value)}
                  label="Enter other subject name"
                  sx={{ mt: 2 }}
                />
                <Button
                  disabled={otherText === ""}
                  variant="contained"
                  style={{ height: "50px" }}
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      selectedSubjects: [
                        ...(prev.selectedSubjects || []),
                        otherText,
                      ],
                    }));
                    setOtherText("");
                  }}
                >
                  Add
                </Button>
              </div>
            ) : (
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel>Select Subject</InputLabel>
                <Select
                  label="Select Subject"
                  onChange={handleSelectChange}
                  inputProps={{ "aria-label": "Select Subject" }}
                >
                  {selectedSubjectsArray.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>

{
  formData.program !== "Others" && 
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={otherChecked}
                  onChange={handleOptionChange}
                  value="Other"
                />
              }
              label="Other"
            />
          </FormGroup>
        }

          <Box mt={2}>
            {(formData.selectedSubjects || []).map((item) => (
              <Chip
                key={item}
                label={item}
                onDelete={() => handleDelete(item)}
                color="primary"
                style={{ margin: "5px", background: "#3e3e3e" }}
              />
            ))}
          </Box>
        </div>

        <ButtonsGroup
          nextDisabled={formData?.selectedSubjects?.length <= 0}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
